/* this file is transformed by vux-loader */
/* eslint-disable */
/* this file is transformed by vux-loader */

/* eslint-disable */

/*
 * @Description:
 * @Date: 2019-01-15 19:30:59
 */
import dateFormat from '@/utils/dateFormat';
export var transDate = function transDate(input) {
  if (typeof input == 'number') {
    var year = new Date(input).getFullYear(),
        month = new Date(input).getMonth() + 1,
        day = new Date(input).getDate();
    month = month < 10 ? '0' + month : month;
    day = day < 10 ? '0' + day : day;
    return year + '-' + month + '-' + day;
  } else {
    return;
  }
};
export var transMonth = function transMonth(input) {
  if (typeof input == 'number') {
    var month = new Date(input).getMonth() + 1,
        day = new Date(input).getDate(),
        month = month < 10 ? '0' + month : month;
    var day = day < 10 ? '0' + day : day;
    var hour = new Date(input).getHours() < 10 ? '0' + new Date(input).getHours() : new Date(input).getHours();
    var min = new Date(input).getMinutes() < 10 ? '0' + new Date(input).getMinutes() : new Date(input).getMinutes();
    return month + '月' + day + '日 ' + hour + ':' + min;
  } else {
    return;
  }
};
export var transMonthLine = function transMonthLine(input) {
  if (typeof input == 'number') {
    var month = new Date(input).getMonth() + 1,
        day = new Date(input).getDate(),
        month = month < 10 ? '0' + month : month;
    var day = day < 10 ? '0' + day : day;
    var hour = new Date(input).getHours() < 10 ? '0' + new Date(input).getHours() : new Date(input).getHours();
    var min = new Date(input).getMinutes() < 10 ? '0' + new Date(input).getMinutes() : new Date(input).getMinutes();
    return month + '-' + day + '- ' + hour + ':' + min;
  } else {
    return;
  }
};
export var todayMedical = function todayMedical(input) {
  var time = input.replace(/-/g, '/');

  if (new Date().getTime() - new Date(time).getTime() < 86400000) {
    return '今天';
  } else if (new Date().getTime() - new Date(time).getTime() < 86400000 * 2) {
    return '昨天';
  } else if (new Date().getTime() - new Date(time).getTime() < 86400000 * 3) {
    return '前天';
  } else {
    var year = new Date(time).getFullYear(),
        month = new Date(time).getMonth() + 1,
        day = new Date(time).getDate(),
        month = month < 10 ? '0' + month : month;
    var day = day < 10 ? '0' + day : day; // var hour = new Date(time).getHours() < 10 ? '0' + new Date(time).getHours() : new Date(time).getHours()
    // var min = new Date(time).getMinutes() < 10 ? '0' + new Date(time).getMinutes() : new Date(time).getMinutes()

    return year + '年' + month + '月' + day + '日 ';
  }
};
export var transMonths = function transMonths(input) {
  return dateFormat(input, 'YYYY-MM-DD');
};